export default {
    getIE3SwitchMotor(state, getters) {
        let switchMotor = getters.switchEngines.find((engine) => {
            return engine.name == 'test';
        });
        if (!switchMotor) {
            switchMotor = getters.switchEngines.find((engine) => {
                return Object.keys(engine.costs).length > 0 && Object.keys(engine.efficiencies).length > 0;
            });
        }
        return switchMotor;
    },
    getLangage (state) {
        return state.currentLanguage;
    },
    getTextArray: (state) => (key) => {
        return state.langs[key];
    },
    getText: (state, getters) => (key, id) => {
        if (id != undefined) {
            return state.langs[key][id][getters.getLangage];
        }
        return state.langs[key][getters.getLangage];
    },
    getFactoryEngines (state, getters) {
        return (uid) => {
            return getters.factoryEngines.filter((engine) => {
                return engine.factory_uid == uid;
            });
        };
    },
    backgroundFile2() {
        return '/static/img/static_img_viveco.jpg';
    },
    logoFile() {
        return 'static/img/big_logo.png';
    },
    defaultLanguage() {
        return 'fr';
    },

    getPressureInPa : () => (value, unit) => {
        if (unit === 'Pa') {
            return value;
        }
        else if (unit === 'bar') {
            return value * Math.pow(10, 5);
        }
        else if (unit === 'mCe') {
            const hauteurManometriqueTotale = 10.1972;
            return value * Math.pow(10, 5) / hauteurManometriqueTotale;
        }
        throw new Error(`Invalid unit for pressure : ${unit}`);
    },
    getFlowInMeterCubePerSecond : () => (value, unit) => {
        if (unit === 'm³/s') {
            return value;
        }
        else if (unit === 'm³/min') {
            return value / 60;
        }
        else if (unit === 'm³/h') {
            return value / 3600;
        }
        throw new Error(`Invalid unit for flow : ${unit}`);
    },
    getDensity: () => (fluid_type) => {
        if(fluid_type === 'air'){
            return 1.08;
        }
        else if(fluid_type === 'eau'){
            return 0.999564033;
        }
        throw new Error(`Invalid fluid type : ${fluid_type}`);
    },
    computePowerForFlowAndPressureInWatt : (state, getters) => ({flow_value, flow_unit, pressure_value, pressure_unit, fluid_type, efficiency}) => {
      let flow = getters.getFlowInMeterCubePerSecond(flow_value, flow_unit);
      let pressure = getters.getPressureInPa(pressure_value, pressure_unit);
      let density = getters.getDensity(fluid_type);
      return (flow*pressure*density)/(efficiency)
    },
    selectedFactory(state){
        return state.selectedFactory;
    }
}



// WEBPACK FOOTER //
// ./src/store/getters.js